import map from 'lodash/map'
import React, { FC } from 'react'

import { SpecificationsSingle } from '@Components/Product/Specifications/Single'
import { SpecificationsForProduct } from '@Components/Product/Specifications/types'

import { AccordionItem } from '../../../CoreComponents/Accordions/HeaderWithAccordion'

interface SpecificationsMultipleProps {
  data: SpecificationsForProduct[]
}

export const SpecificationsMultiple: FC<SpecificationsMultipleProps> = ({ data }) => (
  <>
    {map(data, item => (
      <AccordionItem
        key={item.id}
        header={item.name.toUpperCase()}
        id={`SpecificationsMultiple_${item.id}`}
      >
        <SpecificationsSingle groups={item.groups} />
      </AccordionItem>
    ))}
  </>
)
